/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Rating_AlexInputs */

const en_onboarding_rating_alex = /** @type {(inputs: Onboarding_Rating_AlexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Game changer for content consumption! I use it for everything from articles to documentation.`)
};

const es_onboarding_rating_alex = /** @type {(inputs: Onboarding_Rating_AlexInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡Un cambio total para el consumo de contenido! La uso para todo, desde artículos hasta documentación.`)
};

/**
* | output |
* | --- |
* | "Game changer for content consumption! I use it for everything from articles to documentation." |
*
* @param {Onboarding_Rating_AlexInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_rating_alex = /** @type {((inputs?: Onboarding_Rating_AlexInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Rating_AlexInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_rating_alex(inputs)
	return en_onboarding_rating_alex(inputs)
});